import axios from 'axios';

export default function log(message) {
  axios.post('/api/v1/mezmoLog', {
    message: message
  });
}